import { render, staticRenderFns } from "./wire-instructions.vue?vue&type=template&id=0e8565f5"
import script from "./wire-instructions.vue?vue&type=script&lang=js"
export * from "./wire-instructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports